import React from 'react';
import { Outlet } from 'react-router-dom';
import { Layout, Typography } from 'antd';
import { CarOutlined } from '@ant-design/icons';

const { Content } = Layout;
const { Title } = Typography;

const AuthLayout: React.FC = () => {
  return (
    <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <Content
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '40px 20px',
        }}
      >
        <div style={{ width: '100%', maxWidth: 420 }}>
          <div
            style={{
              textAlign: 'center',
              marginBottom: 32,
            }}
          >
            <CarOutlined style={{ fontSize: 48, color: '#1890ff' }} />
            <Title level={3} style={{ marginTop: 16, marginBottom: 4 }}>
              ERP Transport
            </Title>
            <Typography.Text type="secondary">
              International Bus Transportation ERP System
            </Typography.Text>
          </div>
          <Outlet />
        </div>
      </Content>
    </Layout>
  );
};

export default AuthLayout;
